module.exports = __webpack_public_path__ + "static/img/loading.09b9f977.gif";